const initialState = {
    filter: {
        from: null,
        to: null,
        document: null,
        regional: null
    },
    isFilter: false
};

const filterExamByCollectiveService = (state=initialState, action) => {
    switch (action.type) {
        case 'FILTER_EXAM_BYCOLLECTIVE_SERVICE':
            
        return{
            ...state,
            filter: action.filter,
            isFilter: action.isFilter
        }
    
        default:
            return state;
    }
}
export default filterExamByCollectiveService;